export default __webpack_public_path__ + "static/media/RequestFabric.e321ee21.svg";